export default __webpack_public_path__ + "media/images/tlo-463ee036292a14fdfbe1a471a389a3fa.png";